import React, { Component, PropTypes } from 'react';
import { IconButton } from 'material-ui';

export default class ToolbarIconButton extends Component {
  static contextTypes = {
    muiTheme: PropTypes.object
  };

  render() {
    let { svgIcon, ...other } = this.props,
      theme = this.context.muiTheme.toolbar,
      icon = React.cloneElement(svgIcon, {
        color: this.context.muiTheme.rawTheme.palette.alternateTextColor,
        hoverColor: theme.menuHoverColor
      }),
      height = theme.height,
      width = 32,
      paddingVer = (height - 24) / 2,
      paddingHor = (width - 24) / 2;

    return (
      <IconButton
        style={{
          padding: paddingVer + 'px ' + paddingHor + 'px ',
          width,
          height
        }}
        {...other}
      >
        {icon}
        {this.props.children}
      </IconButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/ToolbarIconButton.js